<template>
    <cell
        class="cursor-pointer"
        :background="'bg-gray-50 hover:bg-gray-200 dark:bg-gray-800 dark:hover:bg-gray-900'"
        @click.native="toggleCategoryOpen(category)"
    >
        <div v-if="category.primary_field">
            <data-field
                v-if="column.entity"
                :percent="column.entity.getPercent(category.primary_field.key)"
                :value="column.entity.getValue(category.primary_field.key)"
                is-bold
            />
        </div>

        <div v-else></div>
    </cell>
</template>

<script>
import FieldCategory from '@/Models/FieldCategory';
import DataField from '@/Components/Storemanager/DataField';
import Cell from '@/Components/Storemanager/Column/Cell';
import DataColumn from '@/Components/Storemanager/Entities/DataColumn';

export default {
    components: {Cell, DataField},

    props: {
        column: {
            type: DataColumn,
            required: true,
        },
        category: FieldCategory,
    },

    methods: {
        toggleCategoryOpen(category) {
            this.$set(category, 'isOpen', !category.isOpen);
        },
    },
};
</script>
